import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ClientDetailComponent } from './client-detail.component'
import { ClientDetailRoutingModule } from './client-detail.routing'
import { ProfileComponent } from './profile/profile.component'
import { A2Edatetimepicker } from 'ng2-eonasdan-datetimepicker'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { AuditComponent } from './audit/audit.component'
import { MailHistoryComponent } from './mail-history/mail-history.component'
import { ComplianceComponent } from './compliance/compliance.component'
import { DeviceComponent } from './device/device.component'
import { QRCodeModule } from 'angular2-qrcode'
import { TimelineComponent } from './timeline/timeline.component'
import { CommunicationComponent } from './communication/communication.component'
import { NgCircleProgressModule } from 'ng-circle-progress'
import { ModalClientDetailRegistrationComponent } from '../../modal/client-detail/top/registration/modal-client-detail-registration.component'
import { ModalClientDetailSlideshowComponent } from '../../modal/client-detail/top/slideshow/modal-client-detail-slideshow.component'
import { ModalClientDetailComparisonComponent } from '../../modal/client-detail/top/comparison/modal-client-detail-comparison.component'
import { ComparisonSlideComponent } from '../../modal/client-detail/top/comparison/comparison-slide/comparison-slide.component'

import { ModalClientDetailSimulationComponent } from '../../modal/client-detail/top/simulation/modal-client-detail-simulation.component'
import { ModalClientDetailRegistraionMovieComponent } from '../../modal/client-detail/top/registration/registrationMovie/modal-client-detail-registraion-movie.component'
import { ModalClientDetailRegistraionToothComponent } from '../../modal/client-detail/top/registration/registrationTooth/modal-client-detail-registraion-tooth.component'
import { ModalClientDetailRegistraionXrayComponent } from '../../modal/client-detail/top/registration/registrationXray/modal-client-detail-registraion-xray.component'
import { ModalClientDetailRegistraionAlignerComponent } from '../../modal/client-detail/top/registration/registrationAligner/modal-client-detail-registraion-aligner.component'
import { ModalClientDetailRegistraionOtherComponent } from '../../modal/client-detail/top/registration/registrationOther/modal-client-detail-registraion-other.component'
import { ModalClientDetailRegistraionFaceComponent } from '../../modal/client-detail/top/registration/registrationFace/modal-client-detail-registraion-face.component'
import { ModalClientDetailRegistrationDsdComponent } from '../../modal/client-detail/top/registration/registrationDsd/modal-client-detail-registration-dsd.component'

import { ModalClientDetailSlideshowAlignerComponent } from '../../modal/client-detail/top/slideshow/slideshowAligner/modal-client-detail-slideshow-aligner.component'
import { ModalClientDetailSlideshowFaceComponent } from '../../modal/client-detail/top/slideshow/slideshowFace/modal-client-detail-slideshow-face.component'
import { ModalClientDetailSlideshowMovieComponent } from '../../modal/client-detail/top/slideshow/slideshowMovie/modal-client-detail-slideshow-movie.component'
import { ModalClientDetailSlideshowOtherComponent } from '../../modal/client-detail/top/slideshow/slideshowOther/modal-client-detail-slideshow-other.component'
import { ModalClientDetailSlideshowToothComponent } from '../../modal/client-detail/top/slideshow/slideshowTooth/modal-client-detail-slideshow-tooth.component'
import { ModalClientDetailSlideshowXrayComponent } from '../../modal/client-detail/top/slideshow/slideshowXray/modal-client-detail-slideshow-xray.component'
import { ModalClientDetailSlideshowDsdComponent } from '../../modal/client-detail/top/slideshow/slideshowDSD/modal-client-detail-slideshow-dsd.component'

import { ClientTopRegistrationService } from '../../../services/client/client-top/client-top-registration/client-top-registration.service'
import { ClientTopServices } from '../../../services/ClientTop.services'
import { NvD3Module } from 'ng2-nvd3'
import { MatrixServices } from '../../../services/image/matrix.services'
import { AlignerComponent } from './aligner/aligner.component'
import { ReloadComponent } from './reload/reload.component'
import { ShardModule } from '../../../shard.module'
import { CommonsModule } from '../../../commons/commons.module'
import { PipeModule } from '@app/pipes/pipe.module'
import { CommunicationItemComponent } from './communication/communication-item/communication-item.component'
import { ChatModule } from '@commons/chat/chat.module'
import { ModalClientDetailSlideshowDentalComponent } from '@app/app_manager/modal/client-detail/top/slideshow/slideshowDental/modal-client-detail-slideshow-dental.component'
import { ModalClientDetailRegistraionDentalComponent } from '@app/app_manager/modal/client-detail/top/registration/registrationDental/modal-client-detail-registraion-dental.component';
import { ReceiptComponent } from './receipt/receipt.component'

@NgModule({
    imports: [
        CommonModule,
        ClientDetailRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        A2Edatetimepicker,
        FormsModule,
        QRCodeModule,
        NvD3Module,
        CommonsModule,
        ShardModule,
        PipeModule,
        // Specify ng-circle-progress as an import
        NgCircleProgressModule.forRoot({
            // set defaults here
            radius: 100,
            outerStrokeWidth: 16,
            innerStrokeWidth: 8,
            outerStrokeColor: '#0080ff',
            innerStrokeColor: '#53a9ff',
            animationDuration: 300,
        }),
        ChatModule,
    ],
    declarations: [
        ClientDetailComponent,
        ProfileComponent,
        AuditComponent,
        MailHistoryComponent,
        ComplianceComponent,
        DeviceComponent,
        ModalClientDetailRegistrationComponent,
        ModalClientDetailSlideshowComponent,
        ModalClientDetailComparisonComponent,
        ComparisonSlideComponent,
        ModalClientDetailSimulationComponent,
        TimelineComponent,
        CommunicationComponent,
        ModalClientDetailRegistraionAlignerComponent,
        ModalClientDetailRegistraionFaceComponent,
        ModalClientDetailRegistraionMovieComponent,
        ModalClientDetailRegistraionOtherComponent,
        ModalClientDetailRegistraionToothComponent,
        ModalClientDetailRegistraionXrayComponent,
        ModalClientDetailRegistrationDsdComponent,
        ModalClientDetailSlideshowAlignerComponent,
        ModalClientDetailSlideshowFaceComponent,
        ModalClientDetailSlideshowMovieComponent,
        ModalClientDetailSlideshowOtherComponent,
        ModalClientDetailSlideshowToothComponent,
        ModalClientDetailSlideshowXrayComponent,
        ModalClientDetailSlideshowDsdComponent,
        ModalClientDetailSlideshowDentalComponent,
        ModalClientDetailRegistraionDentalComponent,
        AlignerComponent,
        ReloadComponent,
        CommunicationItemComponent,
        ReceiptComponent,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
    exports: [],
    providers: [
        ClientTopRegistrationService,
        ClientTopServices,
        MatrixServices,
    ],
})
export class ClientDetailModule {
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client-detail/client-detail.module.ts